/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const HumanPlusIcon = createIcon({
    displayName: 'HumanPlusIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "M15.835 10V7.665H13.5v-1.33h2.335V4h1.33v2.335H19.5v1.33h-2.335V10h-1.33Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M9.208 8c-1.698 0-2.596.9-2.596 2.6 0 1.7.898 2.6 2.596 2.6 1.697 0 2.596-.9 2.596-2.6.1-1.7-.899-2.6-2.596-2.6Zm0 1.3c.998 0 1.298.3 1.298 1.2 0 .9-.3 1.2-1.298 1.2-.999 0-1.198-.2-1.198-1.1 0-.9.3-1.3 1.198-1.3Zm.1 4.7c-1.997 0-3.595.7-4.394 1.2-.3.2-.499.4-.599.7a7.153 7.153 0 0 1-.083.3c-.1.342-.216.742-.216 1.2-.094 1.13.255 1.995.462 2.509l.037.091h9.486c.2-.5.499-1.3.499-2.3 0-.582-.138-1.095-.242-1.48L14.2 16c-.1-.3-.3-.6-.599-.7-.798-.6-2.396-1.3-4.293-1.3Zm-.1 1.3c1.757 0 3.086.686 3.59.946l.104.054c.1.4.2.9.2 1.3 0 .3 0 .7-.1 1H5.414c-.1-.3-.1-.7-.1-1.1 0-.4.1-.8.2-1.1.698-.4 1.997-1.1 3.694-1.1Z",
            clipRule: "evenodd"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M18 1h2v3h3v2h-3v3h-2V6h-3V4h3V1Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M8 7c-2.2 0-3.5 1.2-3.5 3.4s1.3 3.4 3.5 3.4 3.5-1.2 3.5-3.4S10.2 7 8 7Zm0 2c1.3 0 1.5.5 1.5 1.4 0 .9-.2 1.5-1.5 1.5s-1.5-.5-1.5-1.4C6.5 9.6 6.7 9 8 9Zm0 6c-2.7 0-4.8 1-5.8 1.6-.335.167-.53.475-.702.747a7.626 7.626 0 0 1-.098.153c-.2.5-.4 1.2-.4 2-.1 1.6.4 2.8.7 3.4h12.7c.3-.6.7-1.7.6-3.1 0-.9-.2-1.7-.4-2.3-.1-.4-.4-.7-.8-1-1-.5-3.1-1.5-5.8-1.5Zm0 2c2.29 0 3.908.839 4.625 1.21l.175.09c.2.5.3 1.1.3 1.6 0 .4 0 .7-.1 1.1H3.1c-.1-.4-.1-.8-.1-1.3s.1-.9.3-1.4C4.1 17.8 5.8 17 8 17Z",
            clipRule: "evenodd"
        })
    ]
});
HumanPlusIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'HumanPlusIcon'
};
export { HumanPlusIcon };

//# sourceMappingURL=human-plus.js.map